<template>
  <div class="animated fadeIn">

    <b-card-body>
      <div id="portada">
        <b-row class="border-bottom mb-2">
          <b-col>
            <b-img :src="img" left fluid style="max-height: 100px" alt="Responsive image" class="rounded pb-0"></b-img>
            <h1 class="text-right mb-5">PROFORMA #{{proforma.number}}</h1>
            <p class="text-right"></p>
            <a href="#" class="float-right text-black-50" @click="descargarPDF"><i class="fa fa-download"></i></a>
          </b-col>
        </b-row>
        <b-row class="mb-4 pt-2">
          <b-col sm="6">
            <div><strong>Para</strong>: {{proforma.company_detail.company_name}}</div>
            <div><strong>Rut</strong>: {{proforma.company_detail.company_number}}</div>
            <div><strong>Contacto</strong>: {{proforma.company_detail.contact_name}}</div>
            <div><strong>Periodo</strong>: del {{proforma.start_date|moment}} a {{proforma.end_date|moment}}</div>
            <div><strong>Fecha Emisión</strong>: {{proforma.issue_date|moment}}</div>
          </b-col>

          <b-col sm="6">
            <div class="text-right font-weight-bold">{{proforma.client_customer_detail.company_name}}</div>
            <div class="text-right">{{proforma.client_customer_detail.company_number}}</div>
            <div class="text-right">{{proforma.client_customer_detail.address1}}</div>
            <div class="text-right">{{proforma.client_customer_detail.address2}}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 class="mb-3 mt-4 font-weight-bold">Detalle de guía de despacho:</h6>
            <div class="table-responsive-sm">
              <table class="table  table-sm">
                <thead>
                <tr class="font-weight-bold ">
                  <th class="text-center">Fecha Guia</th>
                  <th class="align-middle">Guía</th>
<!--                  <th class="align-middle">Lote</th>-->
                  <th class="align-middle">Pallet</th>
                  <th class="align-middle">Formato</th>
                  <th class="align-middle">Variedad</th>
<!--                  <th class="align-middle">Condición</th>-->
                  <th class="align-middle">Especificaciones</th>
                  <th class="align-middle">Cantidad</th>
                  <th class="align-middle">Kg Exp</th>
                  <th class="text-right align-middle total-column">USD/Kg</th>
                  <th class="text-right align-middle  total-column">Total (USD)</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="item in proforma.proformacontentdetail">
                  <tr>
                    <td class="text-center align-middle">{{item.waybill_date | moment}}</td>
                    <td class="left align-middle">{{item.waybill}}</td>
<!--                    <td class="left align-middle">{{item.lot}}</td>-->
                    <td class="left align-middle">{{item.pallet}}</td>
                    <td class="left align-middle">{{item.container}}</td>
                    <td class="left align-middle">{{item.variety}}</td>
<!--                    <td class="left align-middle">{{item.condition}}</td>-->
                    <td class="left align-middle">{{item.string_specs}}</td>
                    <td class="left align-middle">{{item.quantity}}</td>
                    <td class="left align-middle">{{item.exportable_kilograms}}</td>
                    <td class="text-right align-middle total-column">{{item.value}}</td>
                    <td class="text-right align-middle total-column">
                      {{multiplication(item.exportable_kilograms,item.value)| decimal}}
                    </td>
                  </tr>
                </template>
                </tbody>
                <tfoot>
                <tr class="font-weight-bold">
                  <td class="text-center"></td>
                  <td class="left"></td>
<!--                  <td class="left"></td>-->
<!--                  <td class="left"></td>-->
                  <td class="left"></td>
                  <td class="left"></td>
                  <td class="left"></td>
                  <td class="left"></td>
                  <td class="left"></td>
                  <td class="left"></td>
                  <td class="text-right total-column">TOTAL</td>
                  <td class="text-right total-column">{{totalUsd|decimal}}</td>
                </tr>
                </tfoot>
              </table>

            </div>
          </b-col>
        </b-row>

<!--        <b-row>-->
<!--          <b-col>-->
<!--            <h6 class="text-center font-weight-bold">-->
<!--              Resumen Créditos-->
<!--            </h6>-->
<!--            <table class="table  table-sm ">-->
<!--              <thead>-->
<!--              <tr class="font-weight-bold text-uppercase">-->
<!--                <th>Item</th>-->
<!--                <th class="text-right">Cantidad</th>-->
<!--                <th class="text-right total-column">Precio</th>-->
<!--                <th class="text-right total-column">Total</th>-->
<!--              </tr>-->
<!--              </thead>-->
<!--              <tbody>-->
<!--              <template v-for="item in proforma.proformadetail">-->
<!--                <tr v-if="item.detail_type==2">-->
<!--                  <td>{{item.description}}</td>-->
<!--                  <td class="text-right">{{item.quantity}}</td>-->
<!--                  <td class="text-right total-column">{{item.price}}</td>-->
<!--                  <td class="text-right total-column">{{multiplication(item.quantity,item.price)}}</td>-->
<!--                </tr>-->
<!--              </template>-->
<!--              </tbody>-->
<!--              <tfoot>-->
<!--              <tr class="font-weight-bold">-->
<!--                <td class="text-center"></td>-->
<!--                <td class="text-right">{{quantityCredits}}</td>-->
<!--                <td class="text-right total-column"></td>-->
<!--                <td class="text-right total-column">$ {{totalCredits}}</td>-->
<!--              </tr>-->
<!--              </tfoot>-->
<!--            </table>-->

<!--          </b-col>-->
<!--        </b-row>-->

        <b-row>
          <b-col>
            <h6 class="font-weight-bold">Otros</h6>
            <b-table small :fields="fields" :items="proforma.proformadetail" foot-clone>
              <template v-slot:cell(price)="row">
                US$ {{row.item.price|decimal}}
              </template>
              <template v-slot:cell(quantity)="row">
                {{row.item.quantity|decimal}}
              </template>
              <template v-slot:cell(total)="row">
                <span v-if="row.item.detail_type==1">-</span>{{multiplication(row.item.price,row.item.quantity)|decimal}}
              </template>

              <template v-slot:foot(total)="row">
                <span>{{totalOther|decimal}}</span>
              </template>
              <template v-slot:foot()="row">

              </template>

            </b-table>
<!--            <table class="table  table-sm">-->
<!--              <thead>-->
<!--              <tr class="font-weight-bold text-uppercase">-->
<!--                <th>Item</th>-->
<!--                <th class="text-right">Cantidad</th>-->
<!--                <th class="text-right total-column">Precio</th>-->
<!--                <th class="text-right total-column">Total</th>-->
<!--              </tr>-->
<!--              </thead>-->
<!--              <tbody>-->
<!--              <template v-for="item in proforma.proformadetail">-->
<!--                <tr v-if="item.detail_type==1">-->
<!--                  <td>{{item.description}}</td>-->
<!--                  <td class="text-right">{{item.quantity}}</td>-->
<!--                  <td class="text-right total-column">{{item.price}}</td>-->
<!--                  <td class="text-right total-column">{{multiplication(item.quantity,item.price)}}</td>-->
<!--                </tr>-->
<!--              </template>-->
<!--              </tbody>-->
<!--              <tfoot>-->
<!--              <tr class="font-weight-bold">-->
<!--                <td class="text-center"></td>-->
<!--                <td class="text-right">{{quantityDebits}}</td>-->
<!--                <td class="text-right total-column"></td>-->
<!--                <td class="text-right total-column">$ {{totalDebits}}</td>-->
<!--              </tr>-->
<!--              </tfoot>-->
<!--            </table>-->
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col>
            <h6 class="text-center font-weight-bold">Resumen de Facturación</h6>
            <table class="table  table-sm">
              <thead>
              <tr class="font-weight-bold ">
                <th>Descripción</th>
                <th class="text-right">Cantidad</th>
                <th class="text-right">Precio</th>
                <th class="text-right">Total (USD)</th>
              </tr>
              </thead>
              <tbody>
              <template>
                <tr>
                  <td>{{proforma.description}}</td>
                  <td class="text-right">1</td>
                  <td class="text-right">1</td>
                  <td class="text-right">{{totalTotal|decimal}}</td>
                </tr>
              </template>
              </tbody>
              <tfoot>
              <tr class="font-weight-bold">
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-right">NETO USD</td>
                <td class="text-right">${{totalTotal|decimal}}</td>
              </tr>
              <tr class="font-weight-bold table-borderless">
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-right">NETO CLP</td>
                <td class="text-right">${{totalClp|entero}}</td>
              </tr>
              <tr class="font-weight-bold table-borderless">
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-right">IVA (19%)</td>
                <td class="text-right">${{totalIva|entero}}</td>
              </tr>
              <tr class="font-weight-bold ">
                <td class="text-center "></td>
                <td class="text-center "></td>
                <td class="text-right font-lg">TOTAL</td>
                <td class="text-right font-lg">${{totalFinal|entero}}</td>
              </tr>
              </tfoot>
            </table>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b>Dólar Observado</b>: ${{proforma.currency}}
          </b-col>
        </b-row>
      </div>
    </b-card-body>
  </div>
</template>

<script>

  import html2pdf from 'html2pdf.js'
  import moment from 'moment';
  import numeral from 'numeral';
  // import locale from 'numeral/locales'

  // numeral.locale('es');

  export default {
    name: "Report",
    props: ['proforma'],
    data() {
      return {
        img: '',
        today: new Date(),
        fields: [
          {key: 'description', label: 'Descripción', class: 'text-left'},
          {
            key: 'detail_type', label: 'Tipo', class: 'text-center',
            formatter: (value, key, item) => {
              return value === 1 ? 'Cobro' : 'Credito'
            },
          },
          {key: 'quantity', label: 'Cantidad', class: 'text-center'},
          {key: 'price', label: 'Precio', class: 'text-center'},
          {key: 'total', label: 'Total (USD)', class: 'text-right'},
        ],
      }
    },
    filters: {
      moment: function (date) {
        return moment(date).format('DD-MM-YYYY');
      },
      decimal(value) {
        value = parseFloat(value);
        return numeral(value).format('0,0.00');
      },
      entero(value) {
        value = parseFloat(value);
        return numeral(value).format('0,0');
      }
    },
    mounted() {
      this.img = localStorage.getItem('img');
    },
    computed: {
      groupBy() {

        const arr = this.proforma.proformacontentdetail

        const result = [...arr.reduce((r, o) => {
          const key = o.variety + '-' + o.string_specs;

          const item = r.get(key) || Object.assign({}, o, {
            quantity: 0,
            exportable_kilograms: 0
          });

          item.quantity += o.quantity;
          item.exportable_kilograms += o.exportable_kilograms;

          return r.set(key, item);
        }, new Map).values()];

        return result
      },

      totalOther() {
        let value = 0
          value = this.proforma.proformadetail.reduce((sum, detail) => sum + (detail.detail_type==1?this.multiplication(detail.quantity, detail.price)*-1:this.multiplication(detail.quantity, detail.price)), 0)
        return value
      },
      totalTotal() {
        return this.totalOther+this.totalUsd
      },
      totalClp() {
        return (this.totalTotal*this.proforma.currency).toFixed(0)
      },
      totalIva() {
        return (this.totalClp*0.19).toFixed(0)
      },
      totalFinal() {
        return (this.totalTotal*this.proforma.currency+this.totalClp*0.19).toFixed(0)
      },
      totalUsd() {
        let value = this.proforma.proformacontentdetail.reduce((acc, item) => acc + (item.value ? parseFloat(item.value).toFixed(2) * item.exportable_kilograms : 0), 0);
        return value
      },

    },
    methods: {
      filterTable(row, filter) {
        return row.detail_type != filter;
      },
      descargarPDF() {
        const element = document.getElementById('portada').innerHTML;
        const opt = {
          margin: 0.5,
          // image: {type: 'element', quality: 0.7},
          filename: 'Proforma #' + this.proforma.number +' ('+this.proforma.company_detail.name+').pdf',
          // html2canvas: {scale: 2, letterRendering: true},
          jsPDF: {unit: 'in', format: 'letter', orientation: 'p'}
        };
        // const opt2 = {
        //   jsPDF: {unit: 'in', format: 'letter', orientation: 'landscape'}
        // };
        // html2pdf().from(element1).set(opt1).toPdf().get('pdf').then(function (pdf) {
        //   pdf.addPage('letter', 'l');
        // }).from(element2).set(opt2).toContainer().toCanvas().toPdf().save();
        html2pdf().from(element).set(opt).save();
      },
      multiplication(a, b) {
        a = parseFloat(a);
        b = parseFloat(b);
        return a * b;
      },
      calculateClp(a, b, currency) {
        let value = numeral(a * b * parseFloat(currency));
        return value.format('0,0');
      },
    },
  };


</script>

<style scoped>
  .total-column { max-width: 150px!important; }
</style>
